// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getToken, getCSRF_Token } from "./localStorageService";

// using CSRF token from Local Storage 

// Define a service using a base URL and expected endpoints
export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: fetchBaseQuery({
    // baseUrl: "http://127.0.0.1:8000/api/",
    baseUrl: "https://dummyjson.com/",
    prepareHeaders: headers => {
      // const token =  getCSRF_Token();
      // // console.log('X-CSRF-TOKEN', token);
      // headers.set('X-CSRF-TOKEN', token);
      // return headers;
    },
  }),
  // mode: "no-cors",
  // credentials: "include",
  // tagTypes: ['User'],
  // global configuration for the api
  // refetchOnFocus: true,
  endpoints: (builder) => ({
    addUser: builder.mutation({
      query: (user) => {
        return {
          url: "add_user",
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    updateUser: builder.mutation({
      query: (user) => {
        return {
          url: "update_user",
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deleteUser: builder.mutation({
      query: (user) => {
        return {
          url: "delete_user",
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getAllUsers: builder.query({
      query: () => {
        return {
          url: "users",
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          //   authorization: `Bearer ${getToken()}`,
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),

  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useGetAllUsersQuery,

} = userApi;
